module.exports = __webpack_public_path__ + "img/Differentiation-GBM_SPATA.e1764b0e.png";